<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>

      <v-flex xs12 sm12>
        <v-text-field v-model="salesReportDate" :label="$t('sales.sales-date')" disabled></v-text-field>
      </v-flex>

      <v-combobox
        v-model="selectedUsers"
        item-text="userName"
        item-value="userId"
        :label="$t('sales.salesperson')"
        disabled
        chips
        multiple
      ></v-combobox>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title>{{ $t('title.sales-report-confirm') }}</v-card-title>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                type="Number"
                min="0"
                v-model="search"
                append-icon="search"
                :label="$t('sales.stocktaking-search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              id="dt"
              :headers="headers"
              :items="updatedReportItems"
              hide-actions
              class="elevation-1"
              style="width: 100%; margin: 15px 0 0;"
              :customFilter="customFilter"
              :search="search"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                  <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                  <td class="text-xs-right px-2">{{ props.item.quantity }}</td>
                  <td class="text-xs-right px-2">{{ props.item.presentQuantity }}</td>
                </tr>
              </template>
            </v-data-table>

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-layout row wrap justify-end>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="reportSum"
                  class="font-weight-bold"
                  box
                  :label="$t('attributes.total-sales-amount')"
                  prepend-inner-icon="mdi-currency-jpy"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-flex xs12 sm12>
              <v-textarea
                outline
                v-model="comments"
                counter="1000"
                :label="$t('attributes.comments')"
                disabled
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title>{{ $t('attributes.arrival-confirmation') }}</v-card-title>

          <v-data-table
            id="dt"
            :headers="arrivalConfirmHeaders"
            :items="arrivalConfirm"
            hide-actions
            class="elevation-1"
            style="width: 100%; margin: 15px 0 0;"
            :no-data-text="$t('noTableDataAvailable')"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <tr @click="editItem(props.item)">
                <td class="text-xs-left px-2">{{ props.item.shippingDate }}</td>
                <td class="text-xs-left px-2">{{ props.item.slipNumber }}</td>
                <td class="text-xs-left px-2">
                  <v-flex xs3 sm3>
                    <v-btn block color="info" dark @click="editItem(props.item)">
                      <v-icon dark small left>check_circle</v-icon>
                      {{ $t('attributes.arrival-confirmation') }}
                    </v-btn>
                  </v-flex>
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-dialog v-model="updateDialog" max-width="500px">
            <v-card>
              <v-container>
                <v-card-title>
                  {{
                  $t('attributes.arrival-confirmation-detail')
                  }}
                </v-card-title>

                <v-container grid-list-md>
                  <v-layout row warp>
                    <p class="font-weight-bold text-xs-left">
                      {{ $t('attributes.expected-arrival-date') }}:
                      {{ editedItem.shippingDate }}
                    </p>
                  </v-layout>
                  <v-layout row warp>
                    <p class="font-weight-bold text-xs-left">
                      {{ $t('attributes.slip-number') }}:
                      {{ editedItem.slipNumber }}
                    </p>
                  </v-layout>
                  <div style="height: 10px;"></div>

                  <v-data-table
                    :headers="shippingItemDetailHeaders"
                    :items="shippingItemDetail"
                    hide-actions
                    class="elevation-1"
                    style="width: 100%;    margin: 15px 0 0;"
                    :no-data-text="$t('noTableDataAvailable')"
                  >
                    <template slot="headerCell" slot-scope="props">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">{{ props.header.text }}</span>
                        </template>
                        <span>{{ props.header.text }}</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                        <td class="text-xs-right px-2">{{ props.item.quantity }}</td>
                      </tr>
                    </template>
                  </v-data-table>

                  <v-divider></v-divider>
                </v-container>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="close()">
                    <v-icon dark>arrow_back</v-icon>
                    {{ $t('back-btn') }}
                  </v-btn>
                  <v-btn color="blue darken-1" flat @click="stockComplete()">
                    <v-icon dark>check_circle_outline</v-icon>
                    {{ $t('attributes.stock-complete') }}
                  </v-btn>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <div style="height: 35px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="success" dark @click="registSalesReport()" :loading="loading">
            <v-icon dark left>send</v-icon>
            {{ $t('attributes.send-report') }}
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/SalesReport' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    for (let i = 0; i < this.updatedReportItems.length; i++) {
      this.reportSum += Number(
        this.updatedReportItems[i].quantity *
          this.updatedReportItems[i].unitPrice
      )
    }

    this.reportSum = Number(this.reportSum).toLocaleString()

    // 入荷未完了データの取得
    this.getArrivalData()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    }),
    salesReportDate: {
      get() {
        return this.$store.state.salesSession.salesReportDate
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_DATE', value)
      }
    },
    updatedReportItems: {
      get() {
        return this.$store.state.salesSession.salesReportItems
      },
      set(value) {
        this.$store.commit('SET_SALES_REPORT_ITEMS', value)
      }
    },
    selectedUsers: {
      get() {
        return this.$store.state.salesSession.selectedUsers
      },
      set(value) {
        this.$store.commit('SET_SELECTED_USERS', value)
      }
    },
    comments: {
      get() {
        return this.$store.state.salesSession.comments
      },
      set(value) {
        this.$store.commit('SET_REPORT_COMMENTS', value)
      }
    }
  },
  methods: {
    customFilter(items, search) {
      console.log('custom filter')

      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.janCode.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getArrivalData() {
      console.log('getArrivalData')

      let request = {
        storeCode: this.selectedStore.storeCode
      }
      ServerApiCallService.getArrivalData(request)
        .then(response => {
          Object.assign(this.orderDetails, response.data.orderDetails)
          // 重複データの削除
          var uniq = {}
          this.arrivalConfirm = response.data.orderDetails.filter(
            obj =>
              !uniq[obj.orderManagementId] &&
              (uniq[obj.orderManagementId] = true)
          )
          // console.log(this.arrivalConfirm)

          this.arrivalConfirm.forEach(function(row) {
            row.shippingDate = moment(row.shippingDate, 'YYYYMMDD').format(
              'YYYY/MM/DD'
            )
          })
        })
        .catch(error => {})
    },
    registSalesReport() {
      console.log('registSalesReport ')

      this.loading = true

      this.workedUsers = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        this.workedUsers.push(this.selectedUsers[i].userId)
      }

      // console.log(this.workedUsers)
      // console.log(this.selectedReportItems)

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, ''),
        workedUsers: this.workedUsers,
        comments: this.comments,
        sumTotal: Number(this.reportSum.replace(/,/g, '')),
        salesReportDetail: this.updatedReportItems
      }

      ServerApiCallService.registSalesReportByUser(request)
        .then(response => {
          this.loading = false
          this.$router.push({
            name: 'sales/SalesReport'
          })
        })
        .catch(error => {
          this.loading = false
        })
    },
    editItem(item) {
      console.log('editItem')
      this.editedItem = item
      this.shippingItemDetail = this.orderDetails.filter(
        obj => obj.orderManagementId === item.orderManagementId
      )
      this.updateDialog = true
    },
    stockComplete() {
      console.log('stockComplete')
      console.log(this.editedItem)

      let request = {
        orderManagementId: this.editedItem.orderManagementId
      }

      ServerApiCallService.updateArrival(request)
        .then(response => {
          this.updateDialog = false
          this.getArrivalData()
        })
        .catch(error => {})
    },
    close() {
      this.updateDialog = false
    }
  },
  data() {
    return {
      loading: false,
      updateDialog: false,
      editedItem: [],
      search: '',
      salesReportDateForPicker: '',
      selectedReportItems: [],
      menu2: false,
      dialog: false,
      existsOrderData: [],
      dispShippingConfirmBtn: false,
      selectedOrderManagementId: '',
      selectedSlipNumber: '',
      selectedShippingStatus: '',
      selectedCreatedUser: '',
      headers: [
        {
          text: 'JanCode',
          align: 'center',
          value: 'janCode',
          width: '15%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '35%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.sales-number'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          width: '25%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.present'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          width: '25%',
          fixed: true,
          class: 'px-2'
        }
      ],
      salesReportConfirmHeader: [
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.sales-number'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.present'),
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true,
          class: 'px-2'
        }
      ],
      arrivalConfirmHeaders: [
        {
          text: this.$t('attributes.expected-arrival-date'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('attributes.slip-number'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('confirmation'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        }
      ],
      arrivalConfirm: [],
      shippingItemDetailHeaders: [
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.quantity'),
          align: 'right',
          value: 'itemNum',
          sortable: false,
          fixed: false,
          class: 'px-2'
        }
      ],
      shippingItemDetail: [],
      orderDetails: [],
      workedUsers: [],
      salesUsers: [],
      // selectedUsers: ['test1'],
      reportSum: 0
    }
  }
}
</script>

<style>
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
</style>
